import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Event } from "../../../../models/event";
import { EventType } from "../../../../models/event-type";
import { PrintDocument } from "../../../../models/print-document";
import { PrintDocumentControllerService } from "../../../../services/print-document/print-document-controller.service";
import {TranslatedBaseError} from "../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {Utils as FormioUtils} from "formiojs";

@Component({
  selector: "new-print-documents",
  templateUrl: "./new-print-documents.component.html",
})
export class NewPrintDocumentsComponent extends TranslatedBaseError implements OnInit {

  @Input() public printDocument = new PrintDocument();
  @Input() public templateId: string;
  @Input() public searchedName: string;
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public modalAddedEvent = new EventEmitter();
  public title: string = "Add certificate";

  public serviceId: string;
  public certShortName: string = "";

  constructor(private printDocController: PrintDocumentControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    if (this.templateId) {
      this.setTitle();
      this.loadTemplateSchema(this.templateId);
    }
    if (this.searchedName && this.searchedName.length) {
      this.printDocument.name = this.searchedName;
      this.nameChanged(this.searchedName);
    }
  }

  public loadTemplateSchema(templateId: string) {
    this.printDocController.getTemplateSchema(templateId, this.serviceId).subscribe(
      (data) => {
        this.printDocument.formSchema = data;
        const tag = `print-${templateId.trim().toLowerCase()}`.replace("_", "-").replace("--", "-");
        if (!Array.isArray(this.printDocument.formSchema.tags)) {
          this.printDocument.formSchema.tags = [tag];
        } else if (!this.printDocument.formSchema.tags.includes(tag)) {
          this.printDocument.formSchema.tags.push(tag);
        }
        if (tag === "print-applicant-form") {
          FormioUtils.eachComponent(this.printDocument.formSchema.components || [], (comp) => {
            if (!Array.isArray(comp.customClasses)) {
              comp.customClasses = [];
            }
            if (comp.type === "panel") {
              if (!comp.customClasses.includes("print-page-a4")) {
                comp.customClasses.push("print-page-a4");
              }
            } else {
              if (!comp.customClasses.includes("print-space-medium")) {
                comp.customClasses.push("print-space-medium");
              }
            }
          }, true);
        } else {
          FormioUtils.eachComponent(this.printDocument.formSchema.components || [], (comp) => {
            if (!Array.isArray(comp.customClasses)) {
              comp.customClasses = [];
            }
            if (comp.type === "panel") {
              if (!comp.customClasses.includes("modern-print-form")) {
                comp.customClasses.push("modern-print-form");
              }
            } else {
              if (!comp.customClasses.includes("print-space-medium")) {
                comp.customClasses.push("print-space-medium");
              }
            }
          }, true);
        }
      },
    );
  }

  public setTitle() {
    switch (this.templateId) {
      case "GUIDE":
        this.title = this.title.concat(" - Guide");
        break;
      case "GUIDE_OLD":
        this.title = this.title.concat(" - Guide Old");
        break;
      case "APPLICANT_FORM":
        this.title = this.title.concat(" - Applicant Form");
        break;
      case "PAYMENT":
        this.title = this.title.concat(" - Payment");
        break;
      case "SEND_PAGE_FORM":
        this.title = this.title.concat(" - Send Page Form");
        break;
      case "PARTA":
        this.title = this.title.concat(" - Part A");
        break;
    }
  }

  public addNewCertificate() {
    this.printDocument.name = this.printDocument.name.trim().replace(/[^a-zA-Z0-9 _-]/g, "");
    this.printDocument.shortName = this.printDocument.shortName.trim().replace(/[^a-zA-Z0-9 _-]/g, "");
    if (!Array.isArray(this.printDocument.formSchema.components)) {
      this.printDocument.formSchema.components = [];
    }
    if (!Array.isArray(this.printDocument.formSchema.tags)) {
      this.printDocument.formSchema.tags = [];
    }
    if (this.printDocument.formSchema.tags.length === 0) {
      this.printDocument.formSchema.tags.push("print-certificate");
    }
    if (this.printDocument.formSchema.components.length === 0) {
      this.printDocument.formSchema.components.push({
        customClasses: ["print-page-a4"],
        title: "Page 1",
        type: "panel",
        key: "page1",
      });
    }
    this.printDocController.createDocument(this.serviceId, this.printDocument).subscribe(
      (data) => {
        this.responseSuccessful("Document is created!");
        this.modalAddedEvent.emit();
      },
      (error) => {
        return this.showErrorMessage(error);
      },
    );
  }

  public cancel() {
    this.modalClosedEvent.emit(new Event(null, EventType.Cancel));
  }

  public nameChanged(value): void {
    this.certShortName = value;
    this.printDocument.shortName = this.certShortName.substring(0, 20);
  }

}
